import { Skeleton } from "@/components/ui/skeleton";

export function TestimonialCardSkeleton() {
  return (
    <article className="snap-start flex-shrink-0 w-[280px] md:w-[340px] rounded-2xl border border-slate-700/60 bg-slate-900/70 px-5 py-5 md:px-6 md:py-6 shadow-[0_18px_40px_rgba(15,23,42,0.8)] backdrop-blur-md relative flex flex-col animate-fade-in">
      {/* Quote icon skeleton */}
      <div className="absolute -top-3.5 right-4 h-8 w-8 rounded-full bg-gradient-to-br from-emerald-400/30 to-cyan-400/30" />
      
      {/* Quote text skeleton - multiple lines */}
      <div className="space-y-2.5 flex-1">
        <Skeleton className="h-4 w-full bg-slate-800/80" />
        <Skeleton className="h-4 w-full bg-slate-800/80" />
        <Skeleton className="h-4 w-11/12 bg-slate-800/80" />
        <Skeleton className="h-4 w-full bg-slate-800/80" />
        <Skeleton className="h-4 w-9/12 bg-slate-800/80" />
      </div>

      {/* Footer skeleton */}
      <div className="mt-4 border-t border-slate-700/60 pt-3 space-y-2">
        <Skeleton className="h-3.5 w-32 bg-slate-800/80" />
        <Skeleton className="h-3 w-24 bg-slate-800/70" />
        <Skeleton className="h-3 w-28 bg-slate-800/60" />
      </div>
    </article>
  );
}
